import React, { useState } from "react";
import { Card, CardBody } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { BoldBorderOutlineButton, PrimaryButton } from "../../../../Constant";
import { Btn, ToolTip } from "../../../../AbstractElements";
import CommonEdgeButton from "../Common/CommonEdgeButton";
import { EDGE_BOLD_OUTLINE_BUTTONS, EDGE_BOLD_OUTLINE_BUTTONS_LIST } from "../../../../Data/Buttons/EdgeStyle";

const EdgeBoldBorderOutlineButtons = () => {
    const [buttonTooltip, setButttooltip] = useState(false);
    const buttonToggle = () => setButttooltip(!buttonTooltip);
    return (
      <Card>
        <CommonCardHeader title={BoldBorderOutlineButton} span={EDGE_BOLD_OUTLINE_BUTTONS} />
        <CardBody className="btn-showcase">
          <Btn outline color="primary-2x" id="Tooltip-47" className="btn-pill">{PrimaryButton}</Btn>
          <ToolTip target="Tooltip-47" isOpen={buttonTooltip} toggle={buttonToggle}>btn btn-pill btn-outline-primary-2x</ToolTip>
          {EDGE_BOLD_OUTLINE_BUTTONS_LIST.map((data, index) => (
            <CommonEdgeButton key={index} item={data} outline/>
          ))}
        </CardBody>
      </Card>
    );
};

export default EdgeBoldBorderOutlineButtons;
